import React from 'react';
// Images
import EyeBannerImage from '../../assets/images/banners/lady-cinder-dominatrix-in-la-banner-logo.webp';

function EyeBanner() {
  return (
    <section role='img' aria-label='Lady Cinder fire performance banner' className='pb-12'>
      <img
        src={EyeBannerImage}
        alt='Lady Cinder — neon-gothic dominatrix and fire goddess performing with flames'
        width='1200'
        height='400'
        loading='lazy'
        className='lg:mx-auto'
        decoding='async'
      />
    </section>
  );
}

export default EyeBanner;
